import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
    selector: '[aaAutofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit
{
    constructor(private el: ElementRef)
    {
    }

    ngAfterViewInit ()
    {
        this.el.nativeElement.querySelector('input').focus();
    }
}
